import React, { useState, useEffect } from 'react';
import AdminContainer from '../components/layout/AdminContainer';
import { fetchAdminStats } from '../services/api';
import { Users, MessageSquare, Wifi, ShieldAlert, Activity } from 'lucide-react';
import './AdminDashboardPage.css';

export default function AdminStatsPage() {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await fetchAdminStats();
                setStats(data);
            } catch (err) {
                console.error('Failed to load stats:', err);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const cards = stats ? [
        { icon: <Users size={20} />, color: 'blue', value: stats.total_clients, label: 'Total Clients' },
        { icon: <MessageSquare size={20} />, color: 'green', value: stats.total_messages?.toLocaleString(), label: 'Total Messages' },
        { icon: <Activity size={20} />, color: 'indigo', value: stats.active_clients_week, label: 'Active This Week' },
        { icon: <Wifi size={20} />, color: 'amber', value: stats.whatsapp_connected, label: 'WhatsApp Connected' },
        { icon: <ShieldAlert size={20} />, color: 'red', value: stats.ai_suspended_count, label: 'AI Suspended' },
    ] : [];

    return (
        <AdminContainer>
            <div className="admin-page">
                <div className="admin-page-header">
                    <div>
                        <h1><Activity size={22} /> Platform Statistics</h1>
                        <p>Overview of all clients and platform health</p>
                    </div>
                </div>

                {loading ? (
                    <div className="admin-loading">Loading stats...</div>
                ) : (
                    <>
                        <div className="admin-metrics-grid">
                            {cards.map((card, i) => (
                                <div className="admin-metric-card" key={i}>
                                    <div className={`admin-metric-card__icon ${card.color}`}>
                                        {card.icon}
                                    </div>
                                    <div className="admin-metric-card__value">{card.value}</div>
                                    <div className="admin-metric-card__label">{card.label}</div>
                                </div>
                            ))}
                        </div>

                        {/* Revenue / Hosting section — Phase 6 */}
                        <div className="admin-card" style={{ marginBottom: 24 }}>
                            <div className="admin-card__header">
                                <span className="admin-card__title">Revenue & Costs</span>
                            </div>
                            <div className="admin-loading" style={{ padding: 32 }}>
                                Coming in Phase 6 — after subscription billing is enabled
                            </div>
                        </div>

                        {/* Clients by plan — Phase 6 */}
                        <div className="admin-card">
                            <div className="admin-card__header">
                                <span className="admin-card__title">Clients by Plan</span>
                            </div>
                            <div className="admin-loading" style={{ padding: 32 }}>
                                All clients are currently on the free beta plan
                            </div>
                        </div>
                    </>
                )}
            </div>
        </AdminContainer>
    );
}
